import {termsContent} from 'ladder/agents/common2'
import {Primary} from 'ladder/ux/button2'
import React, {useContext, useState} from 'react'
import {Text} from 'ladder/ux/typography2'
import image2 from 'ladder/ux/image2'
import {Modal} from 'ladder/ux/modal2'
import {CenteredCheckbox} from './inputs2'
import {NewLink} from 'ladder/ux/link2'
import {complianceManualUrl} from 'ladder/agents/dashboard/common2'
import {DashboardQueryContext} from 'ladder/agents/dashboard/DashboardQueryContext'

function TermsAndConditions({setShowTerms}) {
  return <div>
    {termsContent()}
    <br/>
    <Primary onClick={() => setShowTerms(false)}
             roundedCorners
             fullWidth>
      Close
    </Primary>
  </div>
}

function AcceptTermsCheckboxContent({setShowTerms, agentTopLevelAgencyLddrSource}) {
  return <div>
    {'I agree to review and comply with the '}
    <NewLink size='body-15' onClick={() => setShowTerms(true)}>
      Agent Terms & Conditions
    </NewLink>
    {' and the '}
    <NewLink size='body-15' popout href={complianceManualUrl(agentTopLevelAgencyLddrSource)}>
      Agent Compliance Manual
    </NewLink>
  </div>
}

function WelcomeToLadderCard() {
  return <div className='welcome-to-ladder-card'>
    <Text desktopSize='body-20' mobileSize='body-17'>
      Welcome to Ladder!
    </Text>
    <img className='welcome-image'
         alt=''
         src={image2.filenameToSrc('fluidless-hurdle.png')}/>
  </div>
}

export function AcceptTermsModal(props) {
  const {mutation, ...q} = useContext(DashboardQueryContext)
  const [isLoading, setIsLoading] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const [showTerms, setShowTerms] = useState(false)

  function onSettled() {
    setIsLoading(false)
  }

  function onClickSignAgentTerms() {
    setIsLoading(true)
    mutation.mutate({def: 'agent/sign-terms', params: {}}, {onSettled})
  }

  return <Modal
      show={!q['agent/accepted-terms?']}
      roundedCorners
      width='l'
      height='l'
      closeable={false}
      title={showTerms ? 'Agent Terms & Conditions' : ''}>
    <div>
      {showTerms && <TermsAndConditions setShowTerms={setShowTerms}/> || <div className='accept-terms-modal'>
        <WelcomeToLadderCard/>
        <Text block size='body-15' color='#707070' style={{alignSelf: 'flex-start'}}>
          Before you get started, please review a few important materials:
        </Text>
        <CenteredCheckbox name='terms-accept'
                          removeBorder
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                          text={<AcceptTermsCheckboxContent
                              setShowTerms={setShowTerms}
                              agentTopLevelAgencyLddrSource={q['agent/top-level-agency-lddr-source']}
                          />}
                          outerBorderColor='light-gray'
                          borderColor='light-gray'

        />
        <Primary disabled={!isChecked}
                 onClick={onClickSignAgentTerms}
                 loading={isLoading}
                 fullWidth
                 roundedCorners>
          Let’s go
        </Primary>
      </div>}
    </div>
  </Modal>
}
